import React from "react";
import Select from "react-select";

const ProducerSelect = ({ id, options, value, onChange, disabled }) => {
    const selectOptions = (options || []).map((o) => ({ value: o.id, label: o.label || o.name }));
    const selectedOption = selectOptions.find((o) => o.value === value) || null;

    return (
        <div className="c-dropdown c-dropdown--dark c-dropdown--sml">
            <Select
                inputId={id}
                classNamePrefix="react-select"
                options={selectOptions}
                value={selectedOption}
                onChange={(opt) => onChange(opt ? opt.value : null)}
                isDisabled={!!disabled}
                isSearchable
            />
        </div>
    );
};

export default ProducerSelect;
